module.exports = __webpack_public_path__ + "static/img/card_02.4bdd44ec.jpg";